import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios from '../utils/axiosInstance';
import config from '../config.json';
import url from '../url.json';
import createActivityImg from '../assets/undraw_creative_thinking_re_9k71.svg';

const EditProfileModal = ({ open, onClose }) => {
    
    const [userData, setUserData] = useState({
        name: '',
        email: '',
    });
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    // 取出單個 Cookie

    useEffect(() => {
        const fetchUserData = async () => {
            const userId = localStorage.getItem('userId'); // 取得當前使用者 ID
            try {
                const response = await axios.get(url.backendHost + config.getUser + userId);
                console.log('[前端] 獲取用戶資料成功:', response.data);
                setUserData({
                    name: response.data.name || '',
                    // email: response.data.email,
                });
            } catch (error) {
                console.error('[前端] 獲取用戶資料失敗:', error);
                // 即使獲取失敗，也保持當前狀態，避免清空
            }
        };

        if (open) {
            fetchUserData();
        } else {
            // 關閉對話框時不清空資料，保持原值以便下次打開時顯示
        }
    }, [open]);

    const handleSave = async () => {
        console.log('[前端] 開始更新個人資料');
        console.log('[前端] 準備發送的資料:', {
            name: userData.name,
            hasCurrentPassword: !!currentPassword,
            hasNewPassword: !!newPassword,
            newPasswordLength: newPassword?.length
        });

        if (!currentPassword) {
            console.log('[前端] 驗證失敗：缺少當前密碼');
            setErrorMessage('請輸入當前密碼進行驗證');
            return;
        }
        if (newPassword && newPassword !== confirmPassword) {
            console.log('[前端] 驗證失敗：新密碼與確認密碼不一致');
            setErrorMessage('新密碼與確認密碼不一致');
            return;
        }

        const userId = localStorage.getItem('userId');
        console.log('[前端] 用戶ID:', userId);
        
        const updateData = {
            name: userData.name,
            currentPassword,
            ...(newPassword && { password: newPassword })
        };
        
        console.log('[前端] 準備發送更新請求:', {
            url: url.backendHost + config.updateUser + userId,
            data: { ...updateData, currentPassword: '***', password: newPassword ? '***' : undefined }
        });

        try {
            const response = await axios.put(url.backendHost + config.updateUser + userId, updateData);
            
            console.log('[前端] 更新成功，回應:', response.data);

            alert('個人資料已更新成功');
            
            // 清空表單
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            setErrorMessage('');
            
            onClose(); 
        } catch (error) {
            console.error('[前端] 更新個人資料失敗:', error);
            console.error('[前端] 錯誤詳情:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
                statusText: error.response?.statusText
            });
            setErrorMessage(error.response?.data?.message || error.response?.data?.error || '更新失敗，請檢查密碼是否正確');
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <div>
                <img className='modal-image' src={createActivityImg} alt="Edit Profile" />
            </div>
            <DialogTitle sx={{ color: 'black', textDecoration: 'none' }}>編輯個人資料</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="姓名"
                    type="text"
                    name="name"
                    value={userData.name}
                    fullWidth
                    variant="standard"
                    onChange={(e) => setUserData({ ...userData, name: e.target.value })}
                />
                <TextField
                    margin="dense"
                    id="currentPassword"
                    label="當前密碼"
                    type="password"
                    name="currentPassword"
                    value={currentPassword}
                    fullWidth
                    required
                    variant="standard"
                    onChange={(e) => setCurrentPassword(e.target.value)}                />
                <TextField
                    margin="dense"
                    id="newPassword"
                    label="新密碼"
                    type="password"
                    name="newPassword"
                    value={newPassword}
                    fullWidth
                    variant="standard"
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <TextField
                    margin="dense"
                    id="confirmPassword"
                    label="確認新密碼"
                    type="password"
                    name="confirmPassword"
                    value={confirmPassword}
                    fullWidth
                    variant="standard"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                />

                {errorMessage && (
                    <Typography color="error" variant="body2" mt={2}>
                        {errorMessage}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
                <Button onClick={onClose}>取消</Button>
                <Button onClick={handleSave} variant="contained">儲存</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditProfileModal;
